type IFullScreenButtonProps = {
  isFullScreenVersion: boolean;
  setFullScreenVersion: (value: boolean) => void;
};

import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { openFullScreenVersion } from '@pages/WorkSchedule/utils';

export const FullScreenButton = ({
  isFullScreenVersion,
  setFullScreenVersion,
}: IFullScreenButtonProps) => (
  <Tooltip
    title={isFullScreenVersion ? 'Компактная версия' : 'Полноэкранная версия'}
    placement={isFullScreenVersion ? 'bottomRight' : 'topRight'}
  >
    <Button
      size="small"
      type="primary"
      data-testid="full-screen"
      icon={
        isFullScreenVersion ? (
          <FullscreenExitOutlined />
        ) : (
          <FullscreenOutlined />
        )
      }
      onClick={() =>
        openFullScreenVersion(isFullScreenVersion, setFullScreenVersion)
      }
    />
  </Tooltip>
);
